export default __webpack_public_path__ + "static/media/mobile_cardinfo.32af869c.webp";